import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Button } from "./ui/button";
import { Reveal } from "./Reveal";
import { SiteImage, useSiteImages } from "./SiteImages";

export const ActionLink = ({ to, children, testId, outline = false, className = "" }) => (
    <Button asChild className={`studio-button ${outline ? "studio-button-outline" : ""} ${className}`}>
        <Link to={to} data-testid={testId}>{children}<ArrowUpRight size={16} aria-hidden="true" /></Link>
    </Button>
);

export const PageIntro = ({ label, children, description, id }) => (
    <section className="page-intro container" data-testid={`${id}-intro`}>
        <Reveal><p className="eyebrow"><span className="section-dot" />{label}</p></Reveal>
        <div className="intro-grid">
            <Reveal><h1 data-testid={`${id}-heading`}>{children}</h1></Reveal>
            <Reveal delay={0.1}><p className="intro-description">{description}</p></Reveal>
        </div>
    </section>
);

export const SectionLabel = ({ children, number }) => <p className="eyebrow"><span className="section-number">{number}</span>{children}</p>;

export const StudioCTA = ({ title, label = "Start a Project", to = "/contact", id = "studio-cta" }) => (
    <section className="cta-band section" data-testid={id}>
        <Reveal className="container cta-layout">
            <div><p className="eyebrow"><span className="section-dot" />Begin a conversation</p><h2 className="display-heading">{title || <>Let’s build how the<br />world <em>sees you.</em></>}</h2></div>
            <ActionLink to={to} testId={`${id}-button`}>{label}</ActionLink>
        </Reveal>
    </section>
);

export const WorkImage = ({ image, alt, className = "", eager = false, ...props }) => {
    const { items } = useSiteImages(); const current = items.find((item) => item.id === image);
    return <SiteImage assetId={image} src={current?.original_url || `/assets/work/${image}.jpg`} alt={alt} loading={eager ? "eager" : "lazy"} fetchPriority={eager ? "high" : "auto"} decoding="async" width={current?.width || 800} height={current?.height || 600} className={className} {...props} />;
};